import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { BodyLarge, Title4 } from '../../components/styles/Typography'
import { theme } from '../../theme/theme'
import { ComponentLayout } from '../../components/layouts/ComponentLayout'
import { Title1 } from '../../components/styles/Typography'

export const Invoices = () => {
  const { t } = useTranslation()

  return (
    <>
      <ComponentLayout>
        <Title1>{t('admin.invoices.title')}</Title1>
      </ComponentLayout>
      <ComponentLayout paddingTop={0}>
        <TempBanner>
          <Title4>{t('admin.invoices.comingSoonTitle')}</Title4>
          <StyledBodyLarge>
            {t('admin.invoices.comingSoonMessage')}{' '}
            <a href="mailto:hello@estercare.com">{t('admin.invoices.comingSoonEmail')}</a>{' '}
            {t('admin.invoices.comingSoonContinue')}
          </StyledBodyLarge>
        </TempBanner>
      </ComponentLayout>
    </>
  )
}

const TempBanner = styled.div`
  background-color: ${theme.color.beigeDark};
  padding: ${theme.spacing.xlarge}px;
  border-radius: ${theme.spacing.medium}px;
`

const StyledBodyLarge = styled(BodyLarge)`
  max-width: 640px;
  a {
    color: ${theme.color.plumMid};
    font-weight: 500;
  }
`
